import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import * as actions from '../../actions'
import conf from '../../config/config'
import { doTrack } from '../../helpers/TaggingSerializer'

import LoadingWheel from '@argos/loading-wheel'
import Alert from '@argos/alert'
import LoadingError from '../../components/LoadingError/LoadingError'
import Sidebar from '../../components/Sidebar/Sidebar'
import HelpLink from '../../components/HelpLink/HelpLink'
import Meta from '../../components/Meta/Meta'
import PromoCard from '../../components/PromoCard/PromoCard'
import CardLinks from '../../components/CardLinks/CardLinks'
import FAQAccordions from '../../components/FAQAccordions/FAQAccordions'
import StarRating from '../../components/StarRating/StarRating'
import LiveChat from '../../components/LiveChat/LiveChat'
import SearchBar from '../../components/SearchBar/SearchBar'

import './CreditOffers.scss'

class CreditOffers extends PureComponent {
  static waitForDataServer (dispatch, params, req, res) {
    return Promise
      .all([
        dispatch(actions.fetchSidebarNav(true)),
        dispatch(actions.fetchPageContent('credit-offers', true)),
        dispatch(actions.fetchPagePromoContent('credit-offers', true))
      ])
      .then(([sidebar, page]) => {
        if (page.payload.id === 0) {
          res.statusCode = 404
        }
      })
  }

  static waitForDataClient (store) {
    return (nextState, transition, callback) => {
      const { dispatch, getState } = store
      const state = getState()
      const page = state.page.page

      if (page && page.permalink === '/help/argos-card/credit-offers/') {
        return callback()
      }

      dispatch(actions.fetchPageContent('credit-offers'))
        .then(() => { callback() })
        .catch(() => { callback() })
    }
  }

  componentDidMount () {
    const { actions, sidebar } = this.props

    if (!sidebar.length) actions.fetchSidebarNav()
    actions.fetchPagePromoContent('credit-offers')
    this.fireAnalytics()
  }

  fireAnalytics = () => {
    if (window.digitalData) {
      window.digitalData.page.pageInfo.pageName = 'ar:help:page:creditoffers'
      window.digitalData.page.pageInfo.templateTitle = 'help_PAGE_creditoffers'
    }

    doTrack('help_initialLoad')
  }

  render () {
    const { sidebar, page, error, promos, promosLoading } = this.props
    const ccn = 'credit-offers'

    if (!page || error) return <LoadingError />

    let creditoffers
    if (promos) {
      creditoffers = <PromoCard promos={promos} />
    } else if (promosLoading) {
      creditoffers = <LoadingWheel contained />
    } else {
      creditoffers = <Alert backgroundColor='mauve' borderColor='mauve' textColor='white'>
        Error loading credit offers, please try again later.
      </Alert>
    }

    return (
      <div id='page-credit-offers' className='helpfaq page'>
        <div id='helpfaqcontent' tabIndex='-1' />

        <Meta pagemeta={page} />

        <div className='container sticky-nav'>
          <div className='xs-row xs-row--negative lg-row'>
            <Sidebar activePage='/help/argos-card/credit-offers/' links={sidebar} sticky />
          </div>
        </div>

        <div className='container sticky-content'>
          <div className='xs-row xs-row--negative lg-row'>
            <div className='xs-12 lg-9 lg-3-offset'>
              <h1 className={ccn + '__title h1'}>{page.title}</h1>
              <p className={ccn + '__text'}>Delicious deals. Exclusive extras. Only with your Argos Card.</p>
              <HelpLink href='/help/argos-card/' data-test={ccn + '--argos-card'}>
                <img className={ccn + '__banner ' + ccn + '__banner--desktop'} src={conf.IMG_DIR + '/argoscard-tablet.jpg'} alt='Apply for an Argos Card' />
                <img className={ccn + '__banner ' + ccn + '__banner--mobile'} src={conf.IMG_DIR + '/argoscard-mobile.jpg'} alt='Apply for an Argos Card' />
              </HelpLink>

              <div className={ccn + '__promos' + (!promos && promosLoading ? ' ' + ccn + '__promos--loading' : '')}>
                {creditoffers}
              </div>

              <p className={ccn + '__text'}>
                Credit subject to status. Argos Limited acts as a credit broker exclusively for the lender, Home Retail Group Card Services Limited.
                <a className={ccn + '__link'} href='/webapp/wcs/stores/servlet/ArgosFSTermsConditionsView?storeId=10151&langId=110'> Terms & conditions apply</a>
              </p>

              <CardLinks />

              <FAQAccordions faqs={page.related_faqs} />

              <StarRating pageId={page.id} />

              <LiveChat
                actions={this.props.actions}
                chatHasEnded={this.props.chatHasEnded}
                chatLoading={this.props.chatLoading}
                chatOnline={this.props.chatOnline}
              />

              <SearchBar position='bottom' />
            </div>
          </div>
        </div>
      </div>
    )
  }
}

CreditOffers.propTypes = {
  sidebar: PropTypes.array,
  page: PropTypes.object,
  error: PropTypes.bool,
  promos: PropTypes.array,
  promosLoading: PropTypes.bool,
  actions: PropTypes.object,
  chatHasEnded: PropTypes.bool,
  chatLoading: PropTypes.bool,
  chatOnline: PropTypes.bool
}

function mapStateToProps (state) {
  return {
    sidebar: state.help.sidebar,
    page: state.page.page,
    error: state.page.pageError,
    promos: state.page.promos,
    promosLoading: state.page.promosLoading,
    promosError: state.page.promosError,
    chatHasEnded: state.page.chatHasEnded,
    chatLoading: state.page.chatLoading,
    chatOnline: state.page.chatOnline
  }
}

function mapDispatchToProps (dispatch) {
  return {
    actions: bindActionCreators(actions, dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(CreditOffers)
